import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import {GNBDataLevelOne, NavLinkProps, RightSubMenuData} from "../../types";
import {DropDownLeft, NavLinks, NavLinksLeftSection} from "../HeaderStyled";
import LeftMenuLi from "./LeftMenuLi";

const NavLink: React.FC<NavLinkProps> = ({
    navMenuHoverEnter,
    navMenuHoverLeave,
    hamSectionActive,
    navGroupData,
    navClickActiveIndex, // to handle mobile
    navHoverActiveIndex, // to handle desktop
    groupIndex,
    navMenuClick,
}: NavLinkProps) => {
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);
    const [{rightSubMenuData, leftSubMenuData}] = useState<{
        rightSubMenuData: RightSubMenuData;
        leftSubMenuData: GNBDataLevelOne[];
    }>(() => {
        const rightSubMenuData: RightSubMenuData = {};
        const leftSubMenuData: GNBDataLevelOne[] = [];
        if (navGroupData.child) {
            navGroupData?.child.map((mainSection: GNBDataLevelOne, index: number) => {
                // adding data to left sub menu
                leftSubMenuData.push(mainSection);
                // adding data to right sub menu
                if (mainSection.child) rightSubMenuData[`ms_${index}`] = mainSection.child;
            });
        }
        return {rightSubMenuData, leftSubMenuData};
    });
    const [activeLeftTabIndex, setActiveLeftTabIndex] = useState<string>("ms_0");
    const [activeLeftTabIndexMob, setActiveLeftTabIndexMob] = useState<string[]>([]);

    const [hamburgerOpenState, setHamburgerOpenState] = useState("");

    // to update state on change of gnb menu link
    useEffect(() => {
        setActiveLeftTabIndex(isMobile ? "" : "ms_0");
        setActiveLeftTabIndexMob([]);
    }, [navHoverActiveIndex, navClickActiveIndex, isMobile]);

    const openSubSectionDiv = useCallback(
        (index: string) => {
            if (isMobile) {
                setActiveLeftTabIndexMob((activeLeftTabIndexMob) => {
                    const newNavSubSecLinks = [...activeLeftTabIndexMob];
                    const activeLinkIndex = newNavSubSecLinks.indexOf(index);
                    if (activeLinkIndex !== -1) {
                        newNavSubSecLinks.splice(activeLinkIndex, 1);
                    } else {
                        newNavSubSecLinks.push(index);
                    }
                    return newNavSubSecLinks;
                });
            } else {
                if (
                    hamburgerOpenState !== "" &&
                    activeLeftTabIndex !== "" &&
                    hamburgerOpenState === activeLeftTabIndex
                )
                    setActiveLeftTabIndex(isMobile ? "" : "ms_0");
                else setActiveLeftTabIndex(index);
            }
        },
        [hamburgerOpenState, activeLeftTabIndex, isMobile],
    );

    return useMemo(() => {
        let sectionShow = isMobile && hamSectionActive ? "sub-show" : "";
        if (navHoverActiveIndex != null && navHoverActiveIndex === groupIndex)
            sectionShow = "active";
        return (
            <NavLinks>
                <div
                    className={`sub-menu mediv ${sectionShow}`}
                    onMouseEnter={() => navMenuHoverEnter(groupIndex)}
                    onMouseLeave={() => navMenuHoverLeave()}
                >
                    <NavLinksLeftSection>
                        <DropDownLeft>
                            <LeftMenuLi
                                leftMenuData={leftSubMenuData}
                                openSubSectionDiv={openSubSectionDiv}
                                activeLeftTabIndex={
                                    isMobile ? activeLeftTabIndexMob : [activeLeftTabIndex]
                                }
                                rightSubMenuData={rightSubMenuData}
                                navMenuClick={navMenuClick}
                                setHamburgerOpenState={setHamburgerOpenState}
                            />
                        </DropDownLeft>
                    </NavLinksLeftSection>
                </div>
            </NavLinks>
        );
    }, [
        groupIndex,
        leftSubMenuData,
        rightSubMenuData,
        activeLeftTabIndexMob,
        hamSectionActive,
        navMenuHoverEnter,
        navMenuHoverLeave,
        navHoverActiveIndex,
        isMobile,
        openSubSectionDiv,
        navMenuClick,
        setHamburgerOpenState,
        activeLeftTabIndex,
    ]);
};

export default NavLink;
